import React from 'react'
import { connect } from 'react-redux'
import QuestionsBase from './QuestionsBase'

import { set_path } from '../actions/'

const mapStateToProps = state => {
  return {}
}

const mapDispatchToProps = dispatch => {
  return {
    setPath: path => dispatch( set_path(path) )
  }
}

class ConnectedQuestionsIndex extends React.Component {
  state = {
    user: null
  }

  componentWillMount() {
    this.props.setPath('questions') // change depending on component
    const {location} = this.props
    if ( location && location.state && location.state.user ) {
      this.setState({user: location.state.user})
    }
  }

  render() {
    return <QuestionsBase header="Questions" questionbase="index" user_id={this.state.user}/>
  }
}

const QuestionsIndex = connect(mapStateToProps, mapDispatchToProps)(ConnectedQuestionsIndex)

export default QuestionsIndex



// WEBPACK FOOTER //
// ./src/js/components/QuestionsIndex.js